import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Group, Text, Stack, Divider } from '@mantine/core';
import { IconMail, IconPhone, IconMapPin } from '@tabler/icons-react';
import { useLanguage } from '@/context/LanguageContext';

export const Footer: React.FC = () => {
  const { t } = useLanguage();
  return (
    <footer
      style={{
        backgroundColor: '#f8f9fa',
        borderTop: '1px solid #dee2e6',
        marginTop: '4rem',
        paddingTop: '3rem',
        paddingBottom: '2rem',
      }}
    >
      <Container size="xl">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '2rem', marginBottom: '2rem' }}>
          <div>
            <Text fw={700} size="lg" mb="md">Luxelo</Text>
            <Text size="sm" c="dimmed">
              Premium products for your lifestyle. Discover our curated collection of quality items.
            </Text>
          </div>

          <div>
            <Text fw={700} mb="md">{t('footer.shop')}</Text>
            <Stack gap="xs">
              <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
                <Text size="sm" c="dimmed" style={{ cursor: 'pointer' }}>
                  {t('footer.allProducts')}
                </Text>
              </Link>
              <Text size="sm" c="dimmed" style={{ cursor: 'pointer' }}>
                {t('footer.newArrivals')}
              </Text>
              <Text size="sm" c="dimmed" style={{ cursor: 'pointer' }}>
                {t('footer.bestSellers')}
              </Text>
              <Text size="sm" c="dimmed" style={{ cursor: 'pointer' }}>
                {t('footer.sale')}
              </Text>
            </Stack>
          </div>

          <div>
            <Text fw={700} mb="md">{t('footer.customerService')}</Text>
            <Stack gap="xs">
              <Link to="/contact" style={{ textDecoration: 'none', color: 'inherit' }}>
                <Text size="sm" c="dimmed" style={{ cursor: 'pointer' }}>
                  {t('footer.contactUs')}
                </Text>
              </Link>
              <Link to="/shipping" style={{ textDecoration: 'none', color: 'inherit' }}>
                <Text size="sm" c="dimmed" style={{ cursor: 'pointer' }}>
                  {t('footer.shippingInfo')}
                </Text>
              </Link>
              <Link to="/returns" style={{ textDecoration: 'none', color: 'inherit' }}>
                <Text size="sm" c="dimmed" style={{ cursor: 'pointer' }}>
                  {t('footer.returnsExchanges')}
                </Text>
              </Link>
              <Link to="/faq" style={{ textDecoration: 'none', color: 'inherit' }}>
                <Text size="sm" c="dimmed" style={{ cursor: 'pointer' }}>
                  {t('footer.faq')}
                </Text>
              </Link>
            </Stack>
          </div>

          <div>
            <Text fw={700} mb="md">{t('footer.contact')}</Text>
            <Stack gap="xs">
              <Group gap="xs">
                <IconMail size={16} style={{ color: '#868e96' }} />
                <Text size="sm" c="dimmed">
                  contact@luxelo.de
                </Text>
              </Group>
              <Group gap="xs">
                <IconPhone size={16} style={{ color: '#868e96' }} />
                <Text size="sm" c="dimmed">
                  +48 123 456 789
                </Text>
              </Group>
              <Group gap="xs" align="flex-start">
                <IconMapPin size={16} style={{ color: '#868e96', marginTop: '2px' }} />
                <Text size="sm" c="dimmed">
                  Warsaw, Poland
                </Text>
              </Group>
            </Stack>
          </div>
        </div>

        <Divider my="md" />

        <Group justify="space-between" align="center">
          <Text size="sm" c="dimmed">
            &copy; {new Date().getFullYear()} Luxelo. {t('footer.rightsReserved')}
          </Text>
          <Group gap="md">
            <Text size="sm" c="dimmed" style={{ cursor: 'pointer' }}>
              {t('footer.privacyPolicy')}
            </Text>
            <Text size="sm" c="dimmed" style={{ cursor: 'pointer' }}>
              {t('footer.termsOfService')}
            </Text>
          </Group>
        </Group>
      </Container>
    </footer>
  );
};

